import { FC, ReactElement } from 'react';

import './BadgeSkeletons.scss';

interface BadgeSkeletonsProps {
    className?: string;
}

export const BadgeSkeletons: FC<BadgeSkeletonsProps> = ({
    className = '',
}): ReactElement => (
    <div className={`badge-skeletons ${className}`} />
);
